<template>
    <div class="ReportEntityDetails__Component">

      <FieldInlineText
        label="אימייל"
        @onChange="onChange"
        :read-only="readOnly"
        v-model="model.Email"/>

      <FieldInlineText
        label="עמלת הסבה"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.Fee" />

      <FieldInlineSelect
        label="יכול לאשר דוחות לתשלום"
        :filterable="false"
        :clearable="false"
        :options="[{Value: true, Text: 'כן'},{Value: false, Text: 'לא'},]"
        v-model="model.AllowsApproval"
        @onChange="onChange"
        :readOnly="readOnly"
        required="true" />

      <FieldInlineSelect
        label="הסבות מופסקות"
        :filterable="false"
        :clearable="false"
        :options="[{Value: true, Text: 'כן'},{Value: false, Text: 'לא'},]"
        v-model="model.ForbidTransfer"
        @onChange="onChange"
        :readOnly="readOnly"
        required="true" />

      <FieldInlineText
        label="מספר פנימי"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.InternalClientId" />

      <FieldInlineSelect
        v-if="!model.IsForeignCitizen"
        :alert-not-exist="true"
        label="עיר"
        :clearable="true"
        :filterable="true"
        :null-is-value="true"
        placeholder="הקלד עיר"
        :options="[]"
        :fetch-options="onSearchCities"
        @onChange="onCityChange"
        :reduce="(item) => item"
        v-model="model.City"
        :readOnly="readOnly" />

      <FieldInlineText
        v-if="model.IsForeignCitizen"
        label="עיר"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.City" />

      <FieldInlineSelect
        v-if="!model.IsForeignCitizen"
        :alert-not-exist="true"
        label="רחוב"
        :clearable="true"
        :filterable="true"
        :null-is-value="true"
        placeholder="הקלד רחוב"
        :options="[]"
        :fetch-options="onSearchCityAddress"
        @onChange="onChange"
        :reduce="(item) => item"
        v-model="model.Street"
        :readOnly="readOnly || !model.City" />

      <FieldInlineText
        v-if="model.IsForeignCitizen"
        label="רחוב"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.Street" />

      <FieldInlineText
        label="מספר בית"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.HouseNumber" />

      <FieldInlineText
        label="מיקוד"
        @onChange="onChange"
        :readOnly="readOnly"
        v-model="model.ZipCode" />

    </div>
</template>

<script>
import FieldInlineText from '@/components/Fields/FieldInlineText.vue';
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
import DriverService from '@/services/DriverService';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ClientEntityDetails',
  components: {
    FieldInlineText,
    FieldInlineSelect,
  },
  props: ['readOnly'],
  data() {
    return {
      model: {
        Email: null,
        Fee: null,
        AllowsApproval: null,
        ForbidTransfer: null,
        InternalClientId: null,
        // Address fields
        Street: null,
        HouseNumber: null,
        City: null,
        ZipCode: null,
        IsForeignCitizen: null,
      },
    };
  },
  computed: {
    ...mapGetters('client', [
      'form',
    ]),
    changesAmount() {
      return Object.keys(this.diff(this.model, this.form)).length;
    },
  },
  created() {
    this.model = { ...this.model, ...this.form };
  },
  methods: {
    onSearchCities({ search, loading, setData, setValue }) {
      if (search.length >= 3) {
        loading(true);
        return DriverService.searchCity(1, 1000, search)
          .then((r) => {
            if (!r.data.Items.length) {
              setValue({ Value: -1, Text: search });
            } else {
              setData(r.data.Items.map((i) => ({ Value: i.Id, Text: i.Name })));
            }
          })
          .finally(() => {
            loading(false);
          });
      }
      return null;
    },
    onSearchCityAddress({ search, loading, setData, setValue }) {
      if (search.length >= 2) {
        loading(true);
        const cityName = this.model.City?.Text || this.model.City;
        return DriverService.searchCityAddress(cityName, 1, 1000, search)
          .then((r) => {
            if (!r.data.Items.length) {
              setValue({ Value: -1, Text: search });
            } else {
              const items = r.data.Items.map((i) => ({ Value: i.Id, Text: i.Name }));
              items.unshift({ Value: -1, Text: search });
              setData(items);
            }
          })
          .finally(() => {
            loading(false);
          });
      }
      return null;
    },
    onCityChange() {
      this.model.Street = null;
      this.onChange();
    },
    diff(o1, o2) {
      const diff = Object.keys(o2).reduce((diff1, key) => {
        if (o1[key] && typeof o1[key].getMonth === 'function') {
          if (new Date(o1[key]).toString() === new Date(o2[key]).toString()) return diff1;
        }
        if (typeof o1[key] === 'number') {
          if (parseInt(o1[key], 10) === parseInt(o2[key], 10)) return diff1;
        }
        if (o1[key] && typeof o1[key] === 'object' && typeof o1[key].getMonth !== 'function') {
            if (o1[key]?.Id === o2[key]?.Id) return diff1;
        }
        if (o1[key] === o2[key]) return diff1;
        return {
          ...diff1,
          [key]: o2[key],
        };
      }, {});

      return diff;
    },
    onChange() {
      this.$emit('onFormChange', this.changesAmount);
    },
    cancel() {
      this.model = { ...this.model, ...this.form };
    },
    save() {
      this.$emit('onFormSave', {
        model: this.model,
        cancel: this.cancel,
        setRestorePoint: this.setRestorePoint,
      });
    },
    setRestorePoint() {
      this.storeClientDetails(this.model);
    },
    refresh() {
      this.model = { ...this.model, ...this.form };
    },
    ...mapMutations('client', [
      'storeClientDetails',
    ]),
  },
};
</script>

<style>

</style>
